import * as createAd from './create-ad';
import dashboard from './dashboard';

export default {
  createAd,
  dashboard
};
